/* eslint-disable */
import request from './helpers'

export function listAlert () {
    return request ({
        url: '/api/v1/manage/alert/list',
        method: 'get'
    })
}

export function listAlertByChannel (id) {
    return request ({
        url: '/api/v1/manage/alert/' + id + '/list',
        method: 'get'
    })
}

export function createAlert (data) {
    return request ({
        url: '/api/v1/manage/alert/create',
        method: 'post',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export function updateAlert (data) {
    return request ({
        url: '/api/v1/manage/alert/update',
        method: 'post',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export function deleteAlert (id) {
    return request ({
        url: '/api/v1/manage/alert/' + id + '/delete',
        method: 'delete'
    })
}

export function listWebhook () {
    return request ({
        url: '/api/v1/manage/webhook/list',
        method: 'get'
    })
}

export function createWebhook (data) {
    return request ({
        url: '/api/v1/manage/webhook/create',
        method: 'post',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export function updateWebhook (data) {
    return request ({
        url: '/api/v1/manage/webhook/update',
        method: 'post',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export function deleteWebhook (id) {
    return request ({
        url: '/api/v1/manage/webhook/' + id + '/delete',
        method: 'delete'
    })
}

export function listReassign () {
    return request ({
        url: '/api/v1/manage/reassign_topic/list',
        method: 'get'
    })
}

export function listReassignByChannel (id) {
    return request ({
        url: '/api/v1/manage/reassign_topic/' + id + '/list',
        method: 'get'
    })
}

export function createReassign (data) {
    return request ({
        url: '/api/v1/manage/reassign_topic/generate',
        method: 'post',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export function deleteReassign (id) {
    return request ({
        url: '/api/v1/manage/reassign_topic/' + id + '/delete',
        method: 'delete'
    })
}

export function verifyReassign (id) {
    return request ({
        url: '/api/v1/manage/reassign_topic/' + id + '/verify',
        method: 'put'
    })
}

export function executeReassign (id, zookeeperConnectAddress) {
    return request ({
        url: '/api/v1/manage/reassign_topic/' + id + '/execute',
        method: 'put',
        params: {
            zookeeperConnectAddress
        },
        headers: {
            'Content-Type': 'application/json'
        }
    })
}
